import React, { createContext, useState, useContext, useEffect, useCallback, useMemo } from 'react';
import AuthService from "../services/AuthService"
import SessionService from '../services/SessionService';
import { Backdrop } from '@mui/material';
import { LoadingContext } from './LoadingProvider';
import MyAlert from '../components/atoms/MyAlert';

export const UserInfoContext = createContext({})

const UserInfoProvider = ({ children }) => {

    const [pers, setPers] = useState([])
    const [currentUser, setCurrentUser] = useState(null)
    const [error, setError] = useState(false)
    const authService = useMemo(()=>new AuthService(), [])
    const sessionService = useMemo(()=>new SessionService(), [])
    const { setOpenLoading, setTextLoading } = useContext(LoadingContext)

    const getLoginInfo = useCallback(async()=>{
        try {
                
            setTextLoading("Obteniendo permisos")
            setOpenLoading(true)
            const res = await sessionService.getLoginInfo()
            const user = res.data.result.user
            const pers = user.permissionNames

            setPers([...pers.map(per=>per.toLowerCase())])
            setCurrentUser(user)

        } catch (error) {
            setError(true)
        } finally {
            setOpenLoading(false)
        }
    }, [setTextLoading, setOpenLoading, sessionService])

    // Función para verificar si tiene un permiso específico
    const hasPermission = useCallback((permission) => {
        return pers.includes(permission.toLowerCase())
    }, [pers])

    useEffect(()=>{
        if (pers.length === 0 && authService.isAuthenticated())
            getLoginInfo()
    },[getLoginInfo, pers.length, authService])

    return <UserInfoContext.Provider value={{
        pers,
        setPers,
        hasPermission,
        currentUser
    }} >
        {children}
        <Backdrop
            sx={{ color: '#fff', zIndex: "tooltip" }}
            open={error}
        >
            <MyAlert 
                title="Hubo un error de permisos"
                message="No se pudo obtener los permisos del usuario"
                postdata="Intenta recargar la página"
            />
        </Backdrop>
    </UserInfoContext.Provider>

}

export default UserInfoProvider

